import type Message from "@/models/conversation/Message";
import type { MemoryMessage } from "@/services/messageService";

/** True when retry removes the failed AI message and any later turns. */
export const willRetryResetConversation = (
  messages: Message[],
  failedAiMessageId: string
): boolean => {
  const failedIndex = messages.findIndex(
    (message) => message.id === failedAiMessageId
  );

  if (failedIndex < 0) {
    return false;
  }

  return failedIndex < messages.length - 1;
};

/** Drop the trailing human turn when prompt already carries the current question. */
export const trimMemoryForRetry = (
  memory: MemoryMessage[],
  prompt: string
): MemoryMessage[] => {
  if (memory.length === 0) {
    return memory;
  }

  const last = memory[memory.length - 1];
  if (last.actor === "human" && last.text === prompt) {
    return memory.slice(0, -1);
  }

  return memory;
};
